import $x from '@/utils/$x';

// 新增课程模板
export async function addCustomCourseTemplate(params) {
  return $x.post('/custom/course/addCustomCourseTemplate', params);
}

// 课程列表
export async function getCustomCourseList(params) {
  return $x.post('/custom/course/getCustomCourseList', params);
}

// 新增课程阶段
export async function addCourseTemplatePhase(params) {
  return $x.post('/custom/course/addCourseTemplatePhase', params);
}

// 修改课程阶段
export async function modifyCourseTemplatePhase(params) {
  return $x.post('/custom/course/modifyCourseTemplatePhase', params);
}

// 删除课程阶段
export async function deleteCourseTemplatePhase(params) {
  return $x.post('/custom/course/deleteCourseTemplatePhase', params);
}

// 排序课程阶段
export async function sortCourseTemplatePhase(params) {
  return $x.post('/custom/course/sortCourseTemplatePhase', params);
}

// 课程详情
export async function queryCustomCourseDetail(params) {
  return $x.post('/custom/course/queryCustomCourseDetail', params);
}

// 修改课程模板
export async function modifyCustomCourseTemplate(params) {
  return $x.post('/custom/course/modifyCustomCourseTemplate', params);
}

// 更新动作序列
export async function updateActionSeqPriority(params) {
  return $x.post('/custom/course/updateActionSeqPriority', params);
}

// 新增动作序列
export async function addActionSequence(params) {
  return $x.post('/custom/course/addActionSequence', params);
}

// 修改动作序列
export async function modifyActionSequence(params) {
  return $x.post('/custom/course/modifyActionSequence', params);
}

// 删除动作序列
export async function deleteActionSequence(params) {
  return $x.post('/custom/course/deleteActionSequence', params);
}

// 操作动作序列
export async function operateCustomCourseTemplate(params) {
  return $x.post('/custom/course/operateCustomCourseTemplate', params);
}

// -----------专属计划列表--------------

// 用户计划列表
export async function getUserPlanList(params) {
  return $x.post('/userplan/getUserPlanList', params);
}
// 用户计划列表
export async function queryUserCurrentTrainingPlan(params) {
  return $x.post('/userplan/queryUserCurrentTrainingPlan', params);
}

// 用户计划详情
export async function getUserPlanDetail(params) {
  return $x.post('/userplan/getUserPlanDetail', params);
}

// 绑定课程
export async function bindCustomCourse(params) {
  return $x.post('/userplan/bindCustomCourse', params);
}

// 新增用户课程 UserPlan
export async function addUserPlanCourse(params) {
  return $x.post('/userplan/addCourse', params);
}

// 修改用户课程
export async function modifyCourse(params) {
  return $x.post('/userplan/modifyCourse', params);
}

// 操作用户课程
export async function operateCourse(params) {
  return $x.post('/userplan/operateCourse', params);
}

// 修改用户课程阶段
export async function modifyPhase(params) {
  return $x.post('/userplan/modifyPhase', params);
}

// 新增用户课程阶段
export async function addUserPlanPhase(params) {
  return $x.post('/userplan/addPhase', params);
}

// 排序用户课程阶段
export async function sortPhases(params) {
  return $x.post('/userplan/sortPhases', params);
}

// 删除用户课程阶段
export async function deleteUserPlanPhase(params) {
  return $x.post('/userplan/deletePhase', params);
}

// 新增用户课程阶段动作
export async function addUserPlanAction(params) {
  return $x.post('/userplan/addAction', params);
}

// 修改用户课程阶段动作
export async function modifyAction(params) {
  return $x.post('/userplan/modifyAction', params);
}

// 排序用户课程阶段动作
export async function sortUserPlanActions(params) {
  return $x.post('/userplan/sortActions', params);
}

// 删除用户课程阶段动作
export async function deleteUserPlanAction(params) {
  return $x.post('/userplan/deleteAction', params);
}

// 用户课程详情
export async function getUserCourseDetail(params) {
  return $x.post('/userplan/getUserCourseDetail', params);
}

// 重置用户课程
export async function resetUserCourse(params) {
  return $x.post('/userplan/resetUserCourse', params);
}

// 设置用户周期课程坐标
export async function setUserPlanCoordinate(params) {
  return $x.post('/userplan/setUserPlanCoordinate', params);
}
